import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/public/site");
      setSite(data);
    } catch {
      setSite(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);
  return <SiteCtx.Provider value={{ site, reload: load }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
